import React, { useContext, createRef, useState } from 'react';
import { store } from './reducer';
import { DataGrid } from '../../../../../../components/DataGrid/DataGrid';
import { localText } from '../../../../../../langs/fa/data-grid';
import formatNumber from '../../../../../../fns/formatNumber';
import Avatar from '../../../../../../components/User/UserAvatar';
import { useHistory } from 'react-router-dom';
import useRules from 'hooks/useRules';
import LinearProgress from '@material-ui/core/LinearProgress';
import { store as mainStore } from '../../../../../../store';
import { rond } from 'fns';
import { isMobile } from 'react-device-detect';

const ref = createRef();

const List = () => {
  const history = useHistory();
  const [rules, hasRule, isAdmin] = useRules();
  const {
    state: {
      progress,
      reports,
      page,
      date,
      customers,
      drivers,
      operators,
      user,
      totalCommission,
    },
    dispatch,
    itemsCountPerPage,
  } = useContext(store);
  const {
    state: {
      Auth: { profile },
    },
  } = useContext(mainStore);
  const columns = [
    {
      field: 'rowNumber',
      headerName: 'ردیف',
      width: 100,
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
    },
    {
      field: 'waybillType',
      headerName: 'نوع بارنامه',
      width: 120,
    },
    {
      field: 'owner',
      headerName: ' صاحب بار',
      flex: 1,
      renderCell: ({ value }) => (
        <>
          {value?._id ? (
            <Avatar user={value} fullName width={30} height={30} />
          ) : null}
        </>
      ),
    },
    {
      field: 'commissionDeposit',
      headerName: 'کارمزد متعلقه',
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 150,
    },
  ];
  const columnAdmin = [
    {
      field: 'rowNumber',
      headerName: 'ردیف',
      width: 100,
    },
    {
      field: 'user',
      headerName: 'کاربر',
      flex: 1,
      renderCell: ({ value }) => (
        <>
          {value?._id ? (
            <Avatar user={value} fullName width={30} height={30} />
          ) : null}
        </>
      ),
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 150,
    },
    {
      field: 'waybillType',
      headerName: 'نوع بارنامه',
      width: 120,
    },
    {
      field: 'commissions',
      headerName: 'کارمزد شرکت',
      flex: 1,
    },
    {
      field: 'owner',
      headerName: ' صاحب بار',
      width: 150,
      renderCell: ({ value }) => (
        <>
          {value?._id ? (
            <Avatar user={value} fullName width={30} height={30} />
          ) : null}
        </>
      ),
    },
    {
      field: 'commissionDeposit',
      headerName: 'کارمزد متعلقه',
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 150,
    },
  ];
  const _waybillType = {
    custom: 'سفارشی',
    police: 'پلیس راهی',
    software: 'کامل',
  };
  const getStatus = (type, isDepo, verified, paidAt) => {
    if (type === 'payCommission') return 'تسویه پورسانت';
    if (isDepo && !verified) return 'در انتظار تخلیه‌';
    if (isDepo && verified && !paidAt) return 'قابل پرداخت';
    if (isDepo && verified && paidAt) return 'پرداخت شده';
  };

  const handlePageChange = (page) => {
    dispatch({ type: 'CHANGE_PAGE', payload: page });
  };
  const handleSelectRow = (selection) => {
    const reportId = selection.row.id;
    const report = reports.docs?.find((report) => report._id === reportId);
    const { order } = report;
    history.push(`/protected/admin/orders/${order._id}`);
  };
  var _reports = reports?.docs?.map
    ? reports.docs.map((report, i) => ({
        id: report._id,
        user: report?.user,
        rowNumber: (Number(page) - 1) * itemsCountPerPage + (i + 1),
        destination: report.order.destination.title,
        waybillType: _waybillType[report.order.waybillType],
        commissions: formatNumber(rond(report.order.commission || 0)),
        owner: report.order.customer,
        status: getStatus(
          report.transactionType,
          report.isDepositCommission,
          report.verified,
          report?.paidAt
        ),
        commissionDeposit: formatNumber(rond(report.amount)),
      }))
    : [];
  return (
    <>
      <div style={isMobile ? {} : { height: 450 }} ref={ref}>
        {progress && <LinearProgress />}
        <DataGrid
          rows={progress ? [] : _reports}
          columns={isAdmin ? columnAdmin : columns}
          localeText={localText}
          pageSize={itemsCountPerPage}
          rowCount={reports?.totalDocs || 0}
          paginationMode="server"
          onPageChange={handlePageChange}
          loading={progress}
          disableMultipleSelection
          //   onCellClick={handleSelectOrder}
          density="compact"
          onCellClick={handleSelectRow}
        />
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gridGap: 10,
          position: isMobile ? 'sticky' : '',
          bottom: isMobile ? 0 : '',
          maxHeight: isMobile ? '60px' : '',
        }}
      >
        {isAdmin && (
          <div
            style={{
              fontSize: isMobile ? 12 : 16,
              fontWeight: isMobile ? 'bolder' : '',
              padding: '6px 4px',
              border: '1px solid #1b5e20',
              background: '#a5d6a7',
            }}
          >
            مانده دریافتی:{' '}
            <strong>
              {formatNumber(
                rond(reports?.totalFootabAmount * 1 - reports?.totalAmount * 1)
              )}
            </strong>{' '}
            تومان
          </div>
        )}
        {isAdmin && (
          <div
            style={{
              fontSize: isMobile ? 12 : 16,
              fontWeight: isMobile ? 'bolder' : '',
              padding: '6px 4px',
              border: '1px solid #673ab7',
              background: '#b39ddb',
            }}
          >
            مجموع کارمزد شرکت:{' '}
            <strong>
              {formatNumber(rond(reports?.totalFootabAmount || 0))}
            </strong>{' '}
            تومان
          </div>
        )}
        <div
          style={{
            fontSize: isMobile ? 12 : 16,
            fontWeight: isMobile ? 'bolder' : '',
            padding: '6px 4px',
            border: '1px solid #ef5350',
            background: '#ef9a9a',
          }}
        >
          مجموع کارمزد متعلقه:{' '}
          <strong>{formatNumber(rond(reports?.totalAmount || 0))}</strong> تومان
        </div>
      </div>
    </>
  );
};

export default React.memo(List);
